// Active-pack registry. Since the 2026-04-20 overhaul only one pack
// exists — `roguelike` — but the registry + localStorage hook stay in
// place so additional styles can be slotted back in later.

import type { ArtPack, ArtPackId } from './pack';
import { roguelikePack } from './packs/roguelike';

const STORAGE_KEY = 'smp.artpack';

export const PACKS: ArtPack[] = [roguelikePack];

function readStoredId(): ArtPackId | null {
  if (typeof location !== 'undefined') {
    const qp = new URL(location.href).searchParams.get('pack');
    if (qp && isValidId(qp)) return qp;
  }
  if (typeof localStorage !== 'undefined') {
    const v = localStorage.getItem(STORAGE_KEY);
    if (v && isValidId(v)) return v;
  }
  return null;
}

function isValidId(id: string): id is ArtPackId {
  return PACKS.some((p) => p.id === id);
}

let cached: ArtPack | null = null;

export function getActivePack(): ArtPack {
  if (cached) return cached;
  const id = readStoredId();
  const found = id ? PACKS.find((p) => p.id === id) : null;
  cached = found ?? roguelikePack;
  return cached;
}

export function setActivePack(id: ArtPackId): void {
  if (!isValidId(id)) return;
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem(STORAGE_KEY, id);
  }
  cached = PACKS.find((p) => p.id === id) ?? roguelikePack;
  if (typeof location !== 'undefined') {
    const url = new URL(location.href);
    url.searchParams.set('pack', id);
    location.assign(url.toString());
  }
}
